import React, { FC, PropsWithChildren, useEffect, useRef, useState } from 'react';

// import library.
import { useFieldArray, useForm, useFormContext, Controller, FormProvider, FieldArrayWithId, ArrayPath } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import NumberFormat from 'react-number-format';
// mui ...
import {
    Avatar, Button, Grid, Typography, Link, Box, Paper, TextField,
    MenuItem, IconButton, Checkbox, FormControlLabel, Stack
} from '@mui/material';

import { ThreeDots, ThreeCircles } from 'react-loader-spinner';

import { debounce } from 'lodash';

import EnhancedTable, { HeadCell, RowCheckedMode } from './EnhancedTable';
import { FaSearch } from 'react-icons/fa';
import { pink } from '@mui/material/colors';

import { GrFormPreviousLink, GrFormNextLink } from 'react-icons/gr';

import { DataType } from 'features/configuration/models/ExtensionType';
import { DatePicker } from '@mui/x-date-pickers';


export interface ITextFilterElement {
    name: string,
    text: string,

    dataType?: DataType,
    options?: { value: string, name: string }[],

    dateValue?: Date,
    boolValue?: boolean,

    value: string,
}

interface Props {
    filterElements: ITextFilterElement[];
    //setFilterElements: React.Dispatch<React.SetStateAction<ITextFilterElement[]>>;

    onFilterChange: (filterElements: ITextFilterElement[]) => void;
}

export function BasicTextFilterField({ filterElements, onFilterChange }: Props) {

    const { t, i18n } = useTranslation();

    const methods = useForm<{ filterElements: ITextFilterElement[] }>(
        { defaultValues: { filterElements: [...filterElements] } });

    const { register, setValue, getValues, watch, reset, handleSubmit, control, formState: { errors } } = methods;

    let { fields } = useFieldArray<{ filterElements: ITextFilterElement[] }, 'filterElements'>({
        control,
        name: 'filterElements'
    });



    const debouncedFilterChange = useRef(
        debounce( async () => {   
          //setFilterElements( getValues('filterElements'));  
          console.log(getValues('filterElements'));
          onFilterChange( getValues('filterElements') );
        }, 1000)
      ).current;


    useEffect(() => {

        const subscription = watch(async (value, { name, type }) => {
            debouncedFilterChange();  
        });

        return () => subscription.unsubscribe();
    }, [watch]);


    return (
        <>
            <FormProvider {...methods} >
                <Grid container component="main" sx={{ width: '100%' }} alignItems="flex-start">
                    <Grid item xs={12} sm={12} md={12} component={Paper} elevation={2} square>
                        <Stack flexDirection='column' sx={{ width: '100%' }} >
                            <Box sx={{
                                mt: 1, width: '100%',
                                display: 'grid', gap: 1.5, // spacing between items (adjust as needed)
                                gridTemplateColumns: {
                                    xs: 'repeat(3, 1fr)',  // 3 per row on extra-small screens (sx)
                                    sm: 'repeat(4, 1fr)',  // 4 per row on small screens (sm)
                                    md: 'repeat(5, 1fr)',  // 5 per row on medium screens (md) and up
                                },
                            }} >
                                {filterElements.map(({ name, text, value, dataType, options }, idx) =>
                                    ((dataType || 'text') === 'date') ?
                                        <Controller key={`${idx} ${name}`}
                                            render={({ field: { onChange, onBlur, value, ref } }) => (
                                                <DatePicker
                                                    label={text}
                                                    onChange={onChange}
                                                    value={new Date(value ?? new Date())}
                                                    slotProps={{ textField: { sx: { width: `calc(100% - 8px)` } } }}
                                                //renderInput={(params) => <TextField {...params} sx={{width:`calc(${w}% - 8px)`}} />}
                                                />)}
                                            name={`filterElements.${idx}.dateValue`}
                                            control={control}
                                        /> :
                                        ((dataType || 'text') === 'boolean') ?
                                            <FormControlLabel sx={{ width: `calc(100% - 8px)`, whiteSpace: 'nowrap', overflow: 'hidden', m: 0, }}
                                                label={text} key={`${idx} ${name}`}
                                                control={
                                                    <Controller
                                                        name={`filterElements.${idx}.boolValue`}
                                                        control={control}
                                                        render={({ field: { value, onChange, ...props } }) => <Checkbox {...props} checked={value} onChange={onChange} />}
                                                    />} /> :
                                            ((dataType || 'text') === 'enumeration') ?
                                                <Controller key={idx}
                                                    render={({ field: { onChange, value } }) => (
                                                        <TextField select onChange={onChange} value={value} sx={{ width: `calc(100% - 8px)` }}
                                                            label={text} >
                                                            {(options || []).map(
                                                                (opt, ix) => <MenuItem key={`${idx}-${opt.value}`} value={opt.value}>{opt.name}</MenuItem>)
                                                            }
                                                        </TextField>
                                                    )}
                                                    name={`filterElements.${idx}.value`} //defaultValue={param[valueKey]}
                                                    control={control}
                                                /> :
                                                <Controller key={`${idx} ${name}`}
                                                    render={({ field }) => <TextField sx={{ width: `calc(100% - 8px)` }} {...field}
                                                        InputProps={{
                                                            onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => {
                                                                if (event.key === 'Enter') {
                                                                    const btnBasicTextFilter = document.getElementById(`btnBasicTextFilter`);
                                                                    if (btnBasicTextFilter !== null)
                                                                        btnBasicTextFilter?.click();
                                                                }
                                                                //postLogin( new MouseEvent<HTMLButtonElement,MouseEvent>('button') );
                                                            },
                                                        }}
                                                        inputProps={{ autoComplete: 'new-password', style: { textTransform: 'none' } }}
                                                        label={text} />}
                                                    name={`filterElements.${idx}.value`} //defaultValue={value} 
                                                    control={control}
                                                />
                                )
                                }
                            </Box>

                        </Stack>
                    </Grid>

                </Grid>
            </FormProvider>
        </>
    );
}


